'use client';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DealerSearchResult } from '@/types/dealer';

interface DealerStore {
  selectedDealer: DealerSearchResult | null;
  dealersList: DealerSearchResult[];
  searchParams: {
    selectedState: string;
    selectedDistrict: string;
    stateName: string;
    districtName: string;
  } | null;
  setSelectedDealer: (dealer: DealerSearchResult) => void;
  setDealersList: (dealers: DealerSearchResult[]) => void;
  setSearchParams: (params: {
    selectedState: string;
    selectedDistrict: string;
    stateName: string;
    districtName: string;
  }) => void;
  clearDealerData: () => void;
}

export const useDealerStore = create<DealerStore>()(
  persist(
    (set) => ({
      selectedDealer: null,
      dealersList: [],
      searchParams: null,
      setSelectedDealer: (dealer) => set({ selectedDealer: dealer }),
      setDealersList: (dealers) => set({ dealersList: dealers }),
      setSearchParams: (params) => set({ searchParams: params }),
      clearDealerData: () => set({ selectedDealer: null, dealersList: [], searchParams: null }),
    }),
    {
      name: 'dealer-storage',
      getStorage: () => {
        if (typeof window !== 'undefined') {
          return sessionStorage; // Use sessionStorage for dealer data
        }
        return {
          getItem: () => null,
          setItem: () => {},
          removeItem: () => {},
        };
      },
      skipHydration: true, // Prevent hydration mismatches
    },
  ),
);
